import { render, staticRenderFns } from "./SupportChatHeads.vue?vue&type=template&id=432c8ad2&scoped=true&"
import script from "./SupportChatHeads.vue?vue&type=script&lang=ts&"
export * from "./SupportChatHeads.vue?vue&type=script&lang=ts&"
import style0 from "./SupportChatHeads.vue?vue&type=style&index=0&id=432c8ad2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c8ad2",
  null
  
)

export default component.exports